@let analysis = view();
<div data-testid="analysis-overview">
  <div class="mb-[18px] grid grid-cols-2 gap-2.5 md:grid-cols-4">
    <app-coverage-kpi-card
      labelKey="project.steps.rfi.invitationList.analysis.weightedCoverage"
      [value]="(analysis.score | appNumber: '1.2-2') + ' %'"
      [barPercent]="analysis.score"
      data-testid="analysis-score"
    />
    <app-coverage-kpi-card
      labelKey="project.steps.rfi.invitationList.analysis.functionsAvailable"
      [value]="analysis.coveredFunctionCount + ' / ' + analysis.requiredFunctionCount"
      noteKey="project.steps.rfi.invitationList.analysis.note.functionsAvailable"
    />
    <app-coverage-kpi-card
      labelKey="project.steps.rfi.invitationList.analysis.countriesSupported"
      [value]="analysis.supportedCountryCount + ' / ' + analysis.requiredCountryCount"
      noteKey="project.steps.rfi.invitationList.analysis.note.countriesSupported"
    />
    <app-coverage-kpi-card
      labelKey="project.steps.rfi.invitationList.analysis.uncoveredCombinations"
      [value]="analysis.gaps.length"
      noteKey="project.steps.rfi.invitationList.analysis.note.uncoveredCombinations"
    />
  </div>

  <div class="grid gap-3.5 md:grid-cols-2">
    <app-coverage-section titleKey="project.steps.rfi.invitationList.analysis.largestGaps">
      @for (gap of analysis.largestGaps; track $index) {
        <div class="border-themed flex items-center justify-between gap-2.5 border-b py-2.5">
          <div>
            <b>{{ gap.functionName }} · {{ gap.countryName }}</b>
            <div class="text-muted-color text-sm">
              {{ gap.causeKey | transloco }} · {{ gap.employees | appNumber: '1.0-0' }}
              {{ 'project.steps.rfi.invitationList.analysis.employeesUnit' | transloco }}
            </div>
          </div>
          <span class="text-red font-bold whitespace-nowrap">
            −{{ gap.impact | appNumber: '1.2-2' }}
            {{ 'project.steps.rfi.invitationList.analysis.percentagePoints' | transloco }}
          </span>
        </div>
      } @empty {
        <p class="text-green" data-testid="analysis-no-gaps">
          ✓ {{ 'project.steps.rfi.invitationList.analysis.noGaps' | transloco }}
        </p>
      }
      <app-coverage-tab-link
        labelKey="project.steps.rfi.invitationList.analysis.viewAllGaps"
        (clicked)="tabRequested.emit('gaps')"
      />
    </app-coverage-section>

    <app-coverage-section titleKey="project.steps.rfi.invitationList.analysis.basisTitle">
      <p>
        {{
          'project.steps.rfi.invitationList.analysis.basis'
            | transloco
              : {
                  achieved: (analysis.achievedPoints | appNumber: '1.0-0'),
                  possible: (analysis.possiblePoints | appNumber: '1.0-0'),
                }
        }}
      </p>
      <app-rfi-coverage-bar class="my-2 block" [percent]="analysis.score" />
      <p class="text-muted-color mt-2 text-sm">
        {{ 'project.steps.rfi.invitationList.analysis.basisRule' | transloco }}
      </p>
      <app-coverage-tab-link
        labelKey="project.steps.rfi.invitationList.analysis.viewCalculation"
        (clicked)="tabRequested.emit('calculation')"
      />
    </app-coverage-section>
  </div>

  <div
    class="bg-third-level border-themed mt-3 flex items-center justify-between gap-2.5 rounded-md border p-3"
  >
    <div>
      <b>
        {{
          'project.steps.rfi.invitationList.analysis.expansionBanner'
            | transloco
              : {
                  percent: (analysis.expansion.percent | appNumber: '1.1-1'),
                  extra: analysis.expansion.additionalCount,
                }
        }}
      </b>
      <div class="text-muted-color text-sm">
        {{
          'project.steps.rfi.invitationList.analysis.expansionBannerDetail'
            | transloco
              : {
                  requested: analysis.expansion.requestedAvailableCount,
                  extra: analysis.expansion.additionalCount,
                  total: analysis.expansion.availableCount,
                }
        }}
      </div>
    </div>
    <p-button
      [label]="'project.steps.rfi.invitationList.analysis.showFunctions' | transloco"
      severity="secondary"
      size="small"
      (onClick)="tabRequested.emit('extras')"
    />
  </div>
</div>
